import {Injectable} from '@angular/core';

@Injectable()
export class ConfigService {
  // public appVersion = 'custom';
  public appVersion = 'rai'; // TODO remove this and its references

  public forceServer1Hostname: boolean;
  public forceServer2Hostname: boolean;
  public forceServer1Protocol: boolean;
  public forceServer2Protocol: boolean;

  public server1Hostname: string = 'agenzie.emiliaromagna.datastampa.it';
  public server1SSL: boolean = false;
  public server2Hostname: string;
  public server2SSL: boolean;

  constructor() {
    // TODO find a better way to set options for the different versions (external json cfg file)
    this.forceServer1Hostname = true;
    this.forceServer1Protocol = true;
    this.forceServer2Hostname = false;
    this.forceServer2Protocol = false;
  }

  server1Protocol() {
    if (this.server1SSL) {
      return 'https';
    } else {
      return 'http';
    }
  }

  server2Protocol() {
    if (this.server2SSL) {
      return 'https';
    } else {
      return 'http';
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/config-service.ts